import { round } from "mathjs";

export enum ManualEntryType {
  EXPENSE = "EXPENSE",
  INCOME = "INCOME",
}
export enum ManualEntryCategory {
  NONE = "NONE",
  PURCHASE = "PURCHASE",
  WORKFORCE = "WORKFORCE",
  OTHER = "OTHER",
}
export enum ManualEntryStatus {
  PROJECTED = "PROJECTED",
  PAID = "PAID",
}

export class ManualEntry {
  entry_id: string;
  project_id: string;
  eva_company_id: string;
  entry_type: ManualEntryType = ManualEntryType.INCOME;
  category: ManualEntryCategory = ManualEntryCategory.NONE;
  vat_rate: number;
  amount_bt: number;
  amount_pt: number;
  entry_name: string;
  asset_name: string;
  asset_id: string;
  comment: string;
  entry_date: Date;
  status: ManualEntryStatus = ManualEntryStatus.PAID;

  constructor() {
    this.entry_name = "";
    this.amount_bt = 0;
    this.amount_pt = 0;
    this.comment = "";
    this.entry_date = new Date();
  }

  public static createInstance(jsonData: ManualEntry): ManualEntry {
    const m = Object.assign(new ManualEntry(), jsonData);

    m.entry_date = jsonData.entry_date ? new Date(jsonData.entry_date) : null;
    m.comment = jsonData.comment ?? "";

    return m;
  }

  public static createInstances(jsonData: ManualEntry[]): ManualEntry[] {
    return jsonData.map(ManualEntry.createInstance);
  }

  public setVatRate() {
    this.amount_pt = this.computeAmountPt();
  }

  public computeAmountPt(): number {
    let total = this.amount_bt + this.computeVat();

    return total;
  }
  public computeAmountBt(): number {
    let total = round(this.amount_pt / (1 + this.vat_rate / 100), 2);

    return total;
  }

  public computeVat() {
    return round(this.amount_bt * (this.vat_rate / 100), 2) || 0;
  }
}
